import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { BaseDatePicker } from '../BaseDatePicker/BaseDatePicker.js';
import { RangeInput } from '../RangeInput/RangeInput.js';
import { DEFAULT_DATE_FORMAT } from '../constants.js';
import { useRangePicker } from './useRangePicker.js';

/**
 * This component is a replacement for `DatePickerDeprecated`.
 * Read more about migration guide in linked component docs.
 */
function RangePicker(_a) {
    var { children, value, onChange, format = DEFAULT_DATE_FORMAT, "data-testid": dataTestId = "range-datepicker", error, shouldCloseOnSelect = false, monthsShown = 2 } = _a, rest = __rest(_a, ["children", "value", "onChange", "format", "data-testid", "error", "shouldCloseOnSelect", "monthsShown"]);
    const startDate = value === null || value === void 0 ? void 0 : value[0];
    const endDate = value === null || value === void 0 ? void 0 : value[1];
    const { handleChangeRaw } = useRangePicker({ onChange });
    return (jsx(BaseDatePicker, Object.assign({}, rest, { customInput: jsx(RangeInput, { "data-testid": dataTestId, error: error, format: format }), "data-testid": dataTestId, endDate: endDate, format: format, monthsShown: monthsShown, openToDate: startDate !== null && startDate !== void 0 ? startDate : undefined, shouldCloseOnSelect: shouldCloseOnSelect, startDate: startDate, onChange: onChange, onChangeRaw: handleChangeRaw, selectsRange: true, children: children })));
}

export { RangePicker };
//# sourceMappingURL=RangePicker.js.map
